import { render, staticRenderFns } from "./IaraTacDecJudiciaisTcrasTable.vue?vue&type=template&id=176c455c&lang=pug"
import script from "./IaraTacDecJudiciaisTcrasTable.vue?vue&type=script&lang=js"
export * from "./IaraTacDecJudiciaisTcrasTable.vue?vue&type=script&lang=js"
import style0 from "./IaraTacDecJudiciaisTcrasTable.vue?vue&type=style&index=0&id=176c455c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports